import type React from "react";
import { FormattedHTMLMessage } from "react-intl";

interface Props {
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
  showError: boolean;
}

export const RequirementsChecklist: React.FC<Props> = ({
  options,
  selected,
  onChange,
  showError,
}) => {
  const onCheckboxChange = (checkboxValue: string, event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(selected.concat(checkboxValue));
    } else {
      onChange(selected.filter((v) => v !== checkboxValue));
    }
  };

  return (
    <>
      <h2 className="sid-header__subtitle sid-l-space-top-md sid-l-space-btm-md">
        <FormattedHTMLMessage
          id="experiment.step.docUpload.documentMustInclude"
          defaultMessage="Your documents must include:"
        />
      </h2>
      <fieldset className="sid-doc-requirements">
        {options.map((i18nKey) => (
          // Disabling because the linter is kinda broken. the control is INSIDE THE LABEL
          // eslint-disable-next-line jsx-a11y/label-has-associated-control
          <label className="sid-doc-requirements__option">
            <input
              type="checkbox"
              name="requirements"
              value={i18nKey}
              checked={selected.includes(i18nKey)}
              onChange={onCheckboxChange.bind(null, i18nKey)}
              aria-invalid={showError && !selected.includes(i18nKey)}
            />
            <div className="sid-l-space-btm-md">
              <FormattedHTMLMessage id={i18nKey} />
              {showError && !selected.includes(i18nKey) && (
                <div className="sid-field-error">
                  <FormattedHTMLMessage
                    id="step.docUpload.confirm"
                    defaultMessage="Please confirm."
                  />
                </div>
              )}
            </div>
          </label>
        ))}
      </fieldset>
    </>
  );
};
